import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



const cardData = {
  keyword: "Swift Dzire On Rent In Pune",
  heading: "Lotus Cab: Swift Dzire On Rent In Pune",

  headingDescription:
    "Lotus Cab provides reliable and affordable Maruti Suzuki Swift Dzire on rent in Pune for daily city travel, airport transfers, corporate rides, and comfortable outstation journeys. Swift Dzire is one of India’s most preferred sedan cars known for its smooth suspension, impressive fuel efficiency, spacious cabin, and comfortable seating for up to four passengers with luggage space. Whether you require a budget-friendly airport drop, a professional chauffeur-driven sedan for meetings, or a family-friendly vehicle for weekend trips, our AC Dzire taxis ensure a relaxed and economical ride across city and highways. All vehicles are thoroughly maintained, cleaned, sanitized, and inspected before every trip to maintain high safety standards. Our trained, background-verified chauffeurs are punctual, courteous, and experienced in both city traffic and long-distance highway driving. We offer transparent per-kilometer pricing, flexible one-way and round-trip packages, and convenient hourly rental options for local usage. With on-time pickup anywhere in Pune and quick online booking support, Lotus Cab guarantees a smooth, comfortable, safe, and stress-free Swift Dzire rental experience.",

  top: "Top Places to Visit in Pune with Swift Dzire",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is a historic fort and one of Pune’s most iconic heritage landmarks representing the glory of the Maratha Empire. Located in the center of the city, it attracts tourists, history enthusiasts, and families throughout the year. Swift Dzire is ideal for navigating Pune’s city traffic and narrow lanes comfortably while offering smooth suspension and AC comfort. The sedan provides a relaxed sightseeing experience with flexible waiting options for exploring the fort and nearby markets. With Lotus Cab, you can enjoy a hassle-free heritage tour without worrying about parking or traffic."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a serene and historically significant monument associated with India’s freedom movement and Mahatma Gandhi. The spacious gardens and peaceful environment attract families, school groups, and tourists looking for cultural exploration. Swift Dzire ensures comfortable and economical city travel with its smooth driving performance and quiet cabin. Ideal for educational trips and relaxed sightseeing tours. Lotus Cab offers punctual pickup and comfortable AC travel for a pleasant experience."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular weekend getaway near Pune known for its historical importance and scenic hilltop views. The drive includes moderate ghat roads and requires stable vehicle performance. Swift Dzire offers reliable highway performance, strong braking, and comfortable seating for small families. AC comfort makes the journey pleasant even during warm weather. Lotus Cab ensures safe driving and flexible round-trip travel."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "Dagdusheth Halwai Ganpati Temple is one of Pune’s most visited religious destinations. Located in a busy city area, it requires smooth navigation through traffic and crowded streets. Swift Dzire’s compact sedan design allows easy access and parking. Comfortable AC interiors enhance the travel experience for devotees and families."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam is a scenic picnic spot near Pune popular among families and friend groups. Swift Dzire provides economical round-trip travel with excellent mileage and comfortable seating. The smooth suspension ensures relaxed travel on suburban roads. Ideal for short weekend escapes."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a beautiful planned hill city near Pune perfect for short road trips and romantic getaways. Swift Dzire ensures stable highway performance and smooth ghat driving. AC comfort and quiet cabin enhance the travel experience. Lotus Cab provides safe round-trip options."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a famous hill station accessible via the Mumbai-Pune Expressway. Swift Dzire offers stable highway performance, fuel efficiency, and comfortable seating for small family trips. Ideal for one-day or weekend travel. Lotus Cab ensures punctual pickup and safe driving."
    },
    {
      title: "Pune Airport",
      description:
        "Timely airport transfers are important for business and leisure travelers. Swift Dzire provides reliable AC airport pickup and drop service with luggage space. Professional drivers ensure on-time arrival and smooth travel."
    }
  ],

  services: [
    {
      name: "Maruti Suzuki Swift Dzire On Rent in Pune",
      description:
        "Affordable and reliable Swift Dzire rental service in Pune suitable for daily city travel, airport transfers, corporate meetings, and comfortable outstation trips. The vehicle offers spacious seating for four passengers, air-conditioned interiors, excellent fuel efficiency, and smooth suspension for city and highway rides. Ideal for individuals, couples, and small families looking for economical yet comfortable travel. Chauffeur-driven service ensures professional and safe driving experience. Transparent per-km pricing with flexible packages available."
    },
    {
      name: "Dzire Taxi Pune",
      description:
        "Comfortable Dzire taxi service for daily commuting, office travel, and personal trips within Pune. The sedan offers quiet cabin experience, smooth steering, and economical fares. AC interiors maintain comfort during summer travel. Ideal for business professionals and students. Reliable service with punctual pickup and drop."
    },
    {
      name: "Dzire for Outstation Pune",
      description:
        "Budget-friendly outstation sedan service from Pune to Mumbai, Nashik, Mahabaleshwar, Shirdi, and more. Swift Dzire ensures smooth highway performance, excellent mileage, and stable handling on long-distance routes. Suitable for small family trips and couple travel. Comfortable AC seating and professional driver included."
    },
    {
      name: "Dzire Airport Cab Pune",
      description:
        "Reliable AC sedan for Pune airport pickup and drop with adequate luggage space. Swift Dzire ensures timely arrival and comfortable travel for business and leisure passengers. Flight tracking support available. Clean and well-maintained vehicle guaranteed."
    },
    {
      name: "Affordable Dzire Rental Pune",
      description:
        "Economical Dzire rental option with competitive per-km rates and no hidden charges. Ideal for short city rides and budget-conscious travelers. Transparent billing system ensures peace of mind."
    },
    {
      name: "Corporate Sedan Cab Pune",
      description:
        "Professional Swift Dzire sedan service for corporate meetings, executive travel, and office transportation. Clean interiors, punctual service, and trained chauffeur included. Suitable for business professionals and company staff."
    },
    {
      name: "Chauffeur Driven Dzire Pune",
      description:
        "Trained and background-verified drivers ensure safe, courteous, and professional service. Drivers are experienced in city routes and highway travel, ensuring smooth ride."
    },
    {
      name: "Online Dzire Booking Pune",
      description:
        "Instant online booking system with quick confirmation and 24/7 customer support. Easy booking process with flexible payment options available."
    }
  ],
   tableData: [
    ["Swift Dzire On Rent In Pune", "Maruti Suzuki Swift Dzire On Rent in Pune"],
    ["Dzire Taxi Pune", "Dzire for Outstation Pune"],
    ["Dzire Airport Cab Pune", "Affordable Dzire Rental Pune"],
    ["Sedan Cab Pune", "Dzire Per Km Rate Pune"],
    ["AC Dzire Taxi Pune", "Chauffeur Driven Dzire Pune"],
    ["Dzire Drop Service Pune", "Corporate Sedan Cab Pune"],
    ["Online Dzire Booking Pune", "Budget Taxi Pune"],
    ["Family Trip Dzire Pune", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Budget-Friendly Sedan Travel",
      WhyChoosedescription:
        "Swift Dzire offers economical travel without compromising comfort, safety, or reliability, making it ideal for daily and long-distance rides."
    },
    {
      WhyChooseheading: "Excellent Fuel Efficiency",
      WhyChoosedescription:
        "High mileage helps maintain affordable rental pricing, making it cost-effective for city and highway travel."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Experienced, well-trained drivers ensure safe driving, punctual arrival, and courteous service throughout the journey."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear and upfront pricing structure with no hidden fees ensures customer trust and convenience."
    },
    {
      WhyChooseheading: "Reliable Airport Transfers",
      WhyChoosedescription:
        "On-time airport pickup and drop service with luggage assistance and comfortable AC travel."
    },
    {
      WhyChooseheading: "Comfortable AC Interiors",
      WhyChoosedescription:
        "Fully air-conditioned sedan ensures relaxed travel during all seasons."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription:
        "One-way, round-trip, and hourly rental packages available based on travel needs."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock booking and travel assistance available for complete peace of mind."
    }
  ]
};

const faqData = [
  { question: "Is Swift Dzire available for airport transfer?", answer: "Yes, AC Swift Dzire available for Pune airport pickup and drop with timely service and luggage support." },
  { question: "Is driver included?", answer: "Yes, all Swift Dzire rentals are chauffeur-driven with professional drivers included." },
  { question: "Is outstation travel available?", answer: "Yes, Dzire available for outstation trips to major cities with flexible packages." },
  { question: "Is pricing per km transparent?", answer: "Yes, we provide clear per-km pricing with no hidden charges." },
  { question: "Is online booking available?", answer: "Yes, instant online booking available with quick confirmation." },
  { question: "Is vehicle sanitized?", answer: "Yes, vehicles are regularly cleaned and sanitized before each trip." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate sedan service available for business travel." },
  { question: "Is round-trip booking available?", answer: "Yes, flexible round-trip options offered." },
  { question: "Is Dzire suitable for family trips?", answer: "Yes, comfortable for small family travel with luggage space." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock assistance provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Patil",
    feedback:
      "Booked Swift Dzire for airport drop. The vehicle was clean, driver was punctual, and the ride was very smooth. Affordable and professional service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Sharma",
    feedback:
      "Used Dzire for weekend Lonavala trip. Comfortable seating, AC worked perfectly, and pricing was transparent. Highly recommended for budget travelers.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable sedan service for business meetings. Professional driver and on-time pickup made the experience stress-free.",
    rating: 5
  }
];










































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Pune",
  "image": "https://lotuscab.com/assets/images/swift-dzire-rent-pune.jpg", 
  "description": "Lotus Cab offers Maruti Suzuki Swift Dzire on rent in Pune for airport transfers, outstation trips, corporate travel, and family journeys. Comfortable AC sedan with chauffeur service, affordable per km rates, drop services, and easy online booking for safe and reliable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1199",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/swift-dzire-on-rent-pune"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Swift Dzire On Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent Maruti Suzuki Swift Dzire in Pune with Lotus Cab. AC sedan for outstation, airport, corporate & family trips. Chauffeur included. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Maruti Suzuki Swift Dzire On Rent in Pune, Dzire Taxi Pune, Dzire for Outstation Pune, Dzire Airport Cab Pune, Affordable Dzire Rental Pune, Sedan Cab Pune, Dzire Per Km Rate Pune, AC Dzire Taxi Pune, Chauffeur Driven Dzire Pune, Dzire Drop Service Pune, Corporate Sedan Cab Pune, Online Dzire Booking Pune, Budget Taxi Pune, Family Trip Dzire Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinpune;